import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Format, Lookup, Pager, Paging, Popup } from "devextreme-react/data-grid";
import { GroupItem, Item } from "devextreme-react/form";
import { dataGridErrorHandling, showError } from '../../utils/errorHandling';
import { useAssistitiTraumiDataSource } from '../../datasources/AssistitiTraumiDataSource';
import { useScreenSize } from '../../utils/media-query';

type Props = {
  assistitoId: string;
  onchanged?: () => void;
  readOnly?: boolean;
}

export type AssistitoEditTraumiPanelHandle = {
}

const AssistitoEditTraumiPanel: React.ForwardRefRenderFunction<AssistitoEditTraumiPanelHandle, Props> = (props, ref) => {
  const dataSource = useAssistitiTraumiDataSource(props.assistitoId);
  const gridRef = useRef<DataGridRef>(null);

  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
        onRowInserted={props.onchanged}
        onRowRemoved={props.onchanged}
        onRowUpdated={props.onchanged}
      >
        <Editing
          mode="popup"
          allowUpdating={props.readOnly !== true}
          allowAdding={props.readOnly !== true}
          allowDeleting={props.readOnly !== true}>
          <Popup title="Traumi" showTitle={true} />
          <Form colCount={1}>
            <Item dataField="trauma" editorType='dxTextArea' />
            <Item dataField="posizione" editorType='dxTextArea' />
            <Item dataField="dataTrauma" editorType='dxDateBox' isRequired={false}/>
            <Item dataField="causa" editorType='dxTextArea' />
            <Item dataField="dannoProvocato" editorType='dxTextArea'/>
            <Item dataField="terapia" editorType='dxTextArea'/>
          </Form>
        </Editing>
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'trauma'} caption={'Trauma'} />
        <Column dataField={'posizione'} caption={'Posizione'} />
        <Column dataField={'dataTrauma'} caption={'Data Trauma'} dataType='date' format="dd/MM/yyyy" editorOptions={{ type: 'date' }}/>
        <Column dataField={'causa'} caption={'Causa'} />
        <Column dataField={'dannoProvocato'} caption={'Danno Provocato'} />
        <Column dataField={'terapia'} caption={'Terapia'} />
        </DataGrid>
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditTraumiPanel);